import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main className="mx-auto flex max-w-3xl flex-col items-center px-4 py-24 text-center md:px-6">
        <span className="font-heading text-7xl font-black text-primary-500 md:text-8xl">
          404
        </span>
        <h1 className="mt-6 font-heading text-2xl font-extrabold leading-tight text-foreground-950 md:text-4xl">
          {t("notFound.title")}
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
          {t("notFound.text")}
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          <i className="ri-arrow-left-line" aria-hidden="true"></i>
          {t("nav.home")}
        </Link>
      </main>
      <Footer />
    </div>
  );
}